<template>
  <EmailLoader>
    <p>We are happy that you joined our team.</p>
    <p>Click the link below to activate your account!</p>

    <div class="text-center">
      <b-button variant="primary">
        Activate Account
      </b-button>
    </div>
  </EmailLoader>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import EmailLoader from '../setup/loader.vue'

export default {
  components: {
    BButton,
    EmailLoader,
  },
}
</script>
